export const APP_REFRESH = 'APP_REFRESH';

export const refreshApp = () => ({
  type: APP_REFRESH,
});
